import React from 'react';
import { useTranslation } from 'react-i18next';

import { InputRadio } from '../InputRadio';
import { CloudinaryQuality } from '../../../utils/cloudinary';
import { CloudinaryQualitySelectorProps } from './types';
import {
  SelectorContainer,
  Legend,
  OptionsRow,
  OptionRow,
  OptionLabel,
  OptionHint,
} from './styles';

/**
 * Selector de calidad para descarga de imágenes Cloudinary (Tarea #9).
 *
 * Renderiza dos radio buttons accesibles ("Alta" y "Optimizada") y notifica
 * el cambio al padre. Los textos vienen de `multimedia.json` namespace
 * (`multimedia:quality.*`).
 */
export const CloudinaryQualitySelector = ({
  value,
  onChange,
  disabled = false,
}: CloudinaryQualitySelectorProps): JSX.Element => {
  const { t } = useTranslation('multimedia');

  return (
    <SelectorContainer>
      <Legend>{t('quality.title')}</Legend>

      <OptionsRow>
        <OptionRow disabled={disabled}>
          <InputRadio
            name="cloudinary-quality"
            value={CloudinaryQuality.High}
            checked={value === CloudinaryQuality.High}
            onChange={() => onChange(CloudinaryQuality.High)}
            disabled={disabled}
          />
          <OptionLabel>
            {t('quality.high.label')}
            <OptionHint>{t('quality.high.hint')}</OptionHint>
          </OptionLabel>
        </OptionRow>

        <OptionRow disabled={disabled}>
          <InputRadio
            name="cloudinary-quality"
            value={CloudinaryQuality.Optimized}
            checked={value === CloudinaryQuality.Optimized}
            onChange={() => onChange(CloudinaryQuality.Optimized)}
            disabled={disabled}
          />
          <OptionLabel>
            {t('quality.optimized.label')}
            <OptionHint>{t('quality.optimized.hint')}</OptionHint>
          </OptionLabel>
        </OptionRow>
      </OptionsRow>
    </SelectorContainer>
  );
};
